import { Deserializable } from '../protocols/deserializable';
import { SubmissionAvailability } from './submission-availability';
import { BlockingSubmission } from './blocking-submission';

export class IpRetirementProductSubmissionAvailability implements Deserializable {
  public memberId!: number;
  public variableBenefitConfiguration!: SubmissionAvailability;
  public updateVariableBenefitConfiguration!: SubmissionAvailability;
  public variableBenefitPaymentChange!: SubmissionAvailability;
  public monthlyPensionSetup!: SubmissionAvailability;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    this.variableBenefitConfiguration = Deserialize.instanceOf(
      SubmissionAvailability,
      this.variableBenefitConfiguration
    );
    this.updateVariableBenefitConfiguration = Deserialize.instanceOf(
      SubmissionAvailability,
      this.updateVariableBenefitConfiguration
    );
    this.variableBenefitPaymentChange = Deserialize.instanceOf(
      SubmissionAvailability,
      this.variableBenefitPaymentChange
    );
    this.monthlyPensionSetup = Deserialize.instanceOf(SubmissionAvailability, this.monthlyPensionSetup);
  }

  // Each check stops at its first reason, so a board-directed member's update, payment change and monthly
  // pension setup never name the submission in progress; any check that does stands for all of them
  public firstBlockingSubmission(): BlockingSubmission | null {
    return (
      [
        this.variableBenefitConfiguration,
        this.updateVariableBenefitConfiguration,
        this.variableBenefitPaymentChange,
        this.monthlyPensionSetup
      ].find(availability => !!availability.blockingSubmission)?.blockingSubmission ?? null
    );
  }
}
